import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { Flex, Menu } from 'antd';
import cn from 'classnames';

import LogoutIcon from 'assets/images/menu/logout.svg?react';
import ProfileIcon from 'assets/images/menu/profile.svg?react';
import { ShortInfo } from 'entities/User';
import { EMainRoutes } from 'shared/typings';

import styles from './UserNav.module.scss';

interface IUserNavProps extends HTMLAttributes<HTMLDivElement> {
	setIsOpened: (opened: boolean) => void;
}

export const UserNav: FC<IUserNavProps> = ({ className, setIsOpened, ...props }) => {
	const { t } = useTranslation();
	const { pathname } = useLocation();

	return (
		<Flex vertical {...props} className={cn(className, styles.userNav)}>
			<ShortInfo type={'menu'} />
			<Menu
				mode="inline"
				items={[
					{
						label: <Link to={`/${EMainRoutes.PROFILE}`}>{t('Мой профиль')}</Link>,
						key: EMainRoutes.PROFILE,
						icon: <ProfileIcon />,
					},
					{ type: 'divider' },
					{
						label: <a href={`/${EMainRoutes.ACCOUNT}/${EMainRoutes.LOG_OUT}/`}>{t('Выйти')}</a>,
						key: EMainRoutes.LOG_OUT,
						icon: <LogoutIcon />,
					},
				]}
				selectedKeys={[pathname.split('/')[1]]}
				selectable={false}
				onClick={() => setIsOpened(false)}
			/>
		</Flex>
	);
};
